import React, { useEffect, useState } from "react";
import { generateClient } from "aws-amplify/api";
import { Loader2 } from "lucide-react";
import { useParams } from "react-router-dom";
import { getSlumSoccerAwards } from "../graphql/queries";

const client = generateClient();

export default function AwardDetails(props) {
  const { id } = useParams(); // Get project ID from URL
  const [html, setHtml] = useState(null);
  const [award, setAward] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      let pendingData = await client.graphql({
        query: getSlumSoccerAwards,
        variables: { awardId: id },
      });

      const award = pendingData["data"]["getSlumSoccerAwards"];
      const content = JSON.parse(JSON.parse(award.mainContent));
      setAward(award);
      setHtml(content.html);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching project:", error);
      setIsLoading(false);
    }
  };

  const LoadingIndicator = () => (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <Loader2 className="animate-spin text-white" size={64} />
    </div>
  );

  // If loading, show the circular progress indicator
  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <>
      {/* <section className="relative w-full h-screen flex items-center justify-center"> */}

      {/* <!-- Text Overlay --> */}
      {/* <div className="relative z-10 text-center animate-fadeIn">
          <h1 className="text-5xl md:text-6xl font-bold text-white">
            {award.title}
          </h1>
        </div>
      </section> */}

      {/* Information Section */}
      <section className="bg-white text-gray-800 px-5 md:px-15 lg:px-23 py-11">
        <div className="max-w-4xl mx-auto ">
          <div className="text-center mb-8">
            <h2 className="text-4xl font-bold text-orange-500 relative inline-block -mt-5">
              {award.title}
              <div className="h-1 w-full bg-orange-500 mt-2"></div>
            </h2>
          </div>

          {html && (
            <div className="" dangerouslySetInnerHTML={{ __html: html }}></div>
          )}
          {/* <div className="preflight-override">
            {html}
          </div> */}
        </div>
      </section>
    </>
  );
}
